import Home from "./Home"
import Header from "./Header"
function Homepage(){
    return (
        <div>
            <Header/>
            <Home></Home>
        </div>
    )
}

export default Homepage